import React from 'react';
import PropTypes from 'prop-types';
import ModelCardWithTrims from './ModelCardWithTrims';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, MARINE_SITE_NAME, PSP_SITE_NAME, PE_SITE_NAME } from '../../utils/constants';
import useAppName from '../../utils/sitecoreContext/useAppName';
import { isEmpty } from '../../utils/object';
import { getTrimPricing } from './service/utils';
import { BAP_PAYMENT_FREQUENCY, BAP_PAYMENT_METHOD, PAYMENT_FREQUENCY, PAYMENT_METHOD, variant1, variant2, variant3, variant4, variant5, } from './service/constants';
import getTrimWithInteriorColorPricing from './service/getTrimWithInteriorColorPricing';
import getMappedFields from './service/getMappedFields';
const ModelCardWithTrimsWrapper = ({ variant: propVariant, fields, rendering, priceLabels, }) => {
    var _a, _b, _c, _d, _e;
    const appName = useAppName();
    if (!fields || isEmpty(fields))
        return null;
    const mappedFields = getMappedFields(fields, appName);
    if (mappedFields === null || isEmpty(mappedFields)) {
        return null;
    }
    let variant;
    let vehicleType;
    let appPaymentMethod = PAYMENT_METHOD;
    let appPaymentFrequency = PAYMENT_FREQUENCY;
    let trimPricingFormatter = getTrimPricing;
    switch (appName) {
        case PSP_SITE_NAME:
            variant = variant4;
            vehicleType = (_e = (_d = (_c = (_b = (_a = mappedFields === null || mappedFields === void 0 ? void 0 : mappedFields.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.category) === null || _c === void 0 ? void 0 : _c.fields) === null || _d === void 0 ? void 0 : _d.vehicleType) === null || _e === void 0 ? void 0 : _e.name;
            break;
        case MARINE_SITE_NAME:
            variant = variant3;
            break;
        case ACURA_SITE_NAME:
            variant = variant2;
            appPaymentMethod = BAP_PAYMENT_METHOD;
            appPaymentFrequency = BAP_PAYMENT_FREQUENCY;
            trimPricingFormatter = getTrimWithInteriorColorPricing;
            break;
        case HONDA_SITE_NAME:
            variant = variant1;
            trimPricingFormatter = getTrimWithInteriorColorPricing;
            break;
        case PE_SITE_NAME:
            variant = variant5;
            break;
        default:
            break;
    }
    return (React.createElement(ModelCardWithTrims, { componentName: rendering === null || rendering === void 0 ? void 0 : rendering.componentName, fields: mappedFields, priceLabels: priceLabels, variant: propVariant !== null && propVariant !== void 0 ? propVariant : variant, appPaymentMethod: appPaymentMethod, appPaymentFrequency: appPaymentFrequency, vehicleType: vehicleType, trimPricingFormatter: trimPricingFormatter }));
};
ModelCardWithTrimsWrapper.propTypes = {
    fields: PropTypes.shape({
        data: PropTypes.shape({
            value: PropTypes.shape({
                engineSeries: PropTypes.shape({
                    fields: PropTypes.shape({
                        name: PropTypes.string,
                    }),
                }),
            }),
        }),
    }),
    variant: PropTypes.string,
    rendering: PropTypes.shape({
        componentName: PropTypes.string,
    }),
};
export default ModelCardWithTrimsWrapper;
